import styled from 'styled-components'
import logo from './logo.png'
export default function Animacao({fade}){
    return(
        <Iniciando className={fade ? "fade-out" : ""}>
            <section>
                <img src={logo} />
                <article>
                    <p>VIDEO</p>
                    <p>NOTES</p>
                </article>
            </section>
       </Iniciando>
    )
}
const Iniciando=styled.div`
position:fixed;z-index:20;
width:100vw;display:flex;
height:100vh;align-items:center;
justify-content:center;
background:#2a2a3f;
section{display:flex;height:150px;align-items:center;}
img{
height:55%;margin-right:10px;
}
article{
p{margin:0;font-size:30px;
font-family: "Audiowide", sans-serif;color:yellow
}
}
opacity: 1;
  transition: opacity 0.4s ease;

  &.fade-out {
    opacity: 0;
  }
  section {
    animation: subir 0.5s ease-out;
  }

  @keyframes subir {
    from {
      transform: translateY(-200px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`